import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { EMBED_PROVIDER_CONFIG, type EmbedSubtype } from './embed';
import { embedProviderButtonsTestIds } from './EmbedProviderButtons.test-ids';

type Props = {
  onSelectProvider: (subtype: EmbedSubtype) => void;
};

const EmbedProviderButtons = ({ onSelectProvider }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" flexWrap="wrap" gap={2} width="100%">
      <Button
        data-testid={embedProviderButtonsTestIds.googleSheets}
        variant="outlined"
        color="primary"
        startIcon={<img src={EMBED_PROVIDER_CONFIG.GOOGLE_SHEETS.image} alt="Google Sheets" />}
        onClick={() => onSelectProvider('GOOGLE_SHEETS')}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
        sx={{ flex: '1 1 auto', whiteSpace: 'nowrap' }}
      >
        {t('document.grid.embed.empty_placeholder_button_sheets')}
      </Button>
      <Button
        data-testid={embedProviderButtonsTestIds.microsoftExcel}
        variant="outlined"
        color="primary"
        startIcon={<img src={EMBED_PROVIDER_CONFIG.MICROSOFT_EXCEL.image} alt="Microsoft Excel" />}
        onClick={() => onSelectProvider('MICROSOFT_EXCEL')}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
        sx={{ flex: '1 1 auto', whiteSpace: 'nowrap' }}
      >
        {t('document.grid.embed.empty_placeholder_button_excel')}
      </Button>
    </Stack>
  );
};

export default EmbedProviderButtons;
